import { supabase } from './supabase';

const callMuxFunction = async (action, payload = {}, silent = false) => {
  try {
    const { data, error } = await supabase.functions.invoke('mux-handler', {
      body: { action, ...payload },
    });

    if (error) {
      if (!silent) console.error('Edge Function error:', error);
      throw new Error(`Edge Function error: ${error.message || 'Unknown error'}`);
    }

    if (data?.error) {
      if (!silent) console.error('Mux API error response:', data);
      const errorMsg = data.details || data.error || 'Unknown Mux error';
      throw new Error(`Mux error: ${errorMsg}`);
    }

    return data;
  } catch (err) {
    if (!silent) console.error('callMuxFunction error:', err);
    throw err;
  }
};

export const muxService = {
  createLiveStream: async (streamName) => {
    const response = await callMuxFunction('create_stream', {
      name: streamName,
    });
    return response;
  },

  getLiveStream: async (liveStreamId, silent = false) => {
    const response = await callMuxFunction('get_stream', {
      streamId: liveStreamId,
    }, silent);
    return response;
  },

  listLiveStreams: async () => {
    const response = await callMuxFunction('list_streams');
    return response;
  },

  disableLiveStream: async (liveStreamId) => {
    const response = await callMuxFunction('disable_stream', {
      streamId: liveStreamId,
    });
    return response;
  },

  getAsset: async (assetId) => {
    const response = await callMuxFunction('get_asset', {
      assetId,
    });
    return response;
  },

  listAssets: async (limit = 100) => {
    const response = await callMuxFunction('list_assets', {
      limit,
    });
    return response;
  },

  deleteLiveStream: async (liveStreamId) => {
    await callMuxFunction('delete_stream', {
      streamId: liveStreamId,
    });
  },

  getPlaybackId: (stream) => {
    if (stream.playback_ids && stream.playback_ids.length > 0) {
      return stream.playback_ids[0].id;
    }
    return null;
  },

  getIngestUrl: (stream) => {
    // Mux's RTMPS ingest URL is a standard endpoint
    if (stream?.id) {
      return 'rtmps://live.mux.com/app/';
    }
    return null;
  },

  getStreamKey: (stream) => {
    // Stream key is at the top level of the stream object
    if (stream?.stream_key) {
      return stream.stream_key;
    }
    return null;
  },

  getVODPlaybackUrl: (playbackId) => {
    if (playbackId) {
      return `https://stream.mux.com/${playbackId}`;
    }
    return null;
  },

  getVODThumbnailUrl: (playbackId) => {
    if (playbackId) {
      return `https://image.mux.com/${playbackId}/thumbnail.jpg`;
    }
    return null;
  },
};
